export enum OrderTableEnum {

    NotOrder = 0,

    Ascending = 1,

    Descending = 2,
}
